import React from "react";
import "../../css/populare.css";
import Sholinganallur from "../../images/sholinganallur.webp"; 
import perungudi from "../../images/perungudi.webp"; 
import ottiyambakkam from "../../images/ottiyambakkam1.webp"; 


export const Popularlocation = () => {
  return (
    <div className="creators-container">
      <div className="creators-text">
        <h1>
        Top Preferred  
 <br /><span className="color">locations in</span> <br /> chennai</h1>
 
        <p>
        
Find the best properties in top Chennai locations. Explore premium residential, commercial, rental, resale, and lease opportunities in these high-demand areas.
  
          </p>
       
      </div>

      <div className="creators-grid">
        <div className="creator-card large">
          <img src={Sholinganallur} alt="Sholinganallur - PincodePillars" />
          <div className="creator-text">
            <h2>Sholinganallur</h2>
            <p>Tech-Driven Coastal Township</p>
          </div>
        </div>

        <div className="creator-card">
          <img src={perungudi} alt="Perungudi - PincodePillars" />
          <div className="creator-text">
            <h2>Perungudi</h2>
            <p>Smart Living Next to the IT Corridor</p>
          </div>
        </div>

        <div className="creator-card">
          <img src={ottiyambakkam} alt="Ottiyambakkam - PincodePillars" />
          <div className="creator-text">
            <h2>Ottiyambakkam</h2>
            <p>Upcoming Residential Hotspot in South Chennai</p>
          </div>
        </div>
      </div>
    </div>
  )
}
